<template>
  <form class="mx-auto col-sm-12" @submit.prevent>

    <LDBsTable
      url="os-logs"
      defaultSort="createdAt"
      defaultOrder="desc"
      :query="query"
      :columns="columns"
      :clear="clear"
      :defaultOptions='options'
    >
      <div class="form-group col-lg-4">
        <label for="os_number">{{ $t('os_number') }}</label>
        <input
          type="text"
          id="os_number"
          name="os_number"
          class="form-control"
          :placeholder="$t('ph_os_number')"
          v-model="query.os"
        >
      </div>

      <div class="form-group col-lg-4">
        <label for="user">{{ $t('user') }}</label>
        <Combobox
          class="bg-white"
          name='user'
          :placeholder="$t('select_a_item')"
          :options="users"
          :initial-value="query.user"
          label="name"
          v-model="query.user"
          :reduce="user => user.id"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="action">{{ $t('action') }}</label>
        <Combobox
          class="bg-white"
          name='action'
          :placeholder="$t('select_a_item')"
          :options="actions"
          :initial-value="query.action"
          v-model="query.action"
        />
      </div>

      <div class="form-group col-6">
        <label for="contract">{{ $t('contract') }}</label>
        <Combobox
          class="bg-white"
          name='contract'
          :placeholder="$t('select_a_item')"
          :initial-value="query.contract"
          label="contracts"
          :options="contracts"
          v-model="query.contract"
          :reduce="contract => contract.id_contrato"
        />
      </div>

      <div class="form-group col-lg-3">
        <label for="serial">{{ $t('new_equipment') }}</label>
        <input
          type="text"
          id="serial"
          name="serial"
          class="form-control"
          :placeholder="$t('ph_new_equipment')"
          v-model="query.newEquipment"
        >
      </div>

      <div class="form-group col-lg-3">
        <label for="serial">{{ $t('old_equipment') }}</label>
        <input
          type="text"
          id="withdrawnSerial"
          name="withdrawnSerial"
          class="form-control"
          :placeholder="$t('ph_old_equipment')"
          v-model="query.oldEquipment"
        >
      </div>

      <div class="form-group col-lg-6">
        <label for="period_start">{{ $t('period_start') }}</label>
        <input
          type="date"
          id="period_start"
          name="period_start"
          class="form-control"
          :placeholder="$t('ph_period_start')"
          v-model="query.createdAtStart"
        />
      </div>

      <div class="form-group col-lg-6">
        <label for="period_end">{{ $t('period_end') }}</label>
        <input
          type="date"
          id="period_end"
          name="period_end"
          class="form-control"
          :placeholder="$t('ph_period_end')"
          v-model="query.createdAtEnd"
        />
      </div>
    </LDBsTable>

    <!-- MODAL SHOW BODY INFO -->
    <div
      class="modal fade"
      id="modalShowBodyInfo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalShowBodyInfoLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">        
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalShowBodyInfoLabel">Body</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <textarea
              name=""
              id="myTextarea"
              cols="30"
              rows="10"
            />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </button>

            <button
              type="button"
              class="btn btn-primary"
              @click="() => {}"
            >
              {{ $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import { mapState } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import LDBsTable from '@/components/shared/LDBsTable'
import moment from 'moment'

const mapServiceName = {
  1: 'INSTALAÇÃO',
  2: 'MANUTENÇÃO',
  4: 'RETIRADA',
  5: 'TESTE BANCADA',
  6: 'REINSTALAÇÃO'
}
const initialQuery = {
  os            : undefined,
  user          : undefined,
  newEquipment  : undefined,
  oldEquipment  : undefined,
  contract      : undefined,
  action        : undefined,
  createdAtStart: undefined,
  createdAtEnd  : undefined
}

export default {
  name: 'OsLogsListComponent',
  components: {
    LoaderButton,
    Combobox,
    LDBsTable
  },

  data() {
    return {
      columns: [
        {
          title: this.$t('createdAt'),
          field: 'createdAt',
          formatter: function(value) {
            return moment(value).format('DD/MM/YYYY HH:mm:ss')
          },
          sortable: true
        },
        {
          title: 'OS',
          field: 'os',
          // formatter: function(value, item) {
          //   const { services } = JSON.parse(item.body)

          //   return value + ' / ' + mapServiceName[services]
          // }
        },
        {
          title: this.$t('user'),
          field: 'user',
          formatter: function(value) {
            return value.name
          }
        },
        {
          title: this.$t('new_equipment'),
          field: 'newEquipment'
        },
        {
          title: this.$t('old_equipment'),
          field: 'oldEquipment',
        },
        {
          title: this.$t('contract'),
          field: 'contract',
          formatter: function (value) {
            return value
              ? value.contracts
              : '-'
          }
        },
        {
          title: this.$t('command'),
          field: 'command',
        },
        {
          title: this.$t('vehicle'),
          field: 'vehicle'
        },
        {
          title: this.$t('action'),
          field: 'action'
        },
        {
          key: 'id',
          title: 'Body',
          field: 'id',
          align: 'center',
          align: 'center',
          width: '100%',
          formatter: function (value, row) {
            return `
              <button
                title="Body"
                data-target="#modalShowBodyInfo"
                data-body='${row.body}'
                data-toggle="modal"
                class="mb-1 btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-eye" />
              </button>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'usuarios' }
      },
      query: Object.assign({}, initialQuery),
      actions: [
        'INICIADO TESTE',
        'ENVIADO COMANDO',
        'REMOVIDO ÚLTIMO DADO LIDO',
        'OS NÃO FINALIZADA',
        'OS FINALIZADA',
        'COMANDO CANCELADO (INDIVIDUAL)',
        'COMANDO CANCELADO (TODOS)',
        'ALTERADO DADOS DA OS'
      ],
      bodyToShow: {}
    }
  },

  computed: {
    ...mapState({
      users    : state => state.users.all,
      contracts: state => state.contracts.all
    })
  },

  methods: {
    clear() {
      this.query = Object.assign({}, initialQuery)
    },

    mountTextBody() {
      const json = JSON.stringify(this.bodyToShow, undefined, 4)

      $('#myTextarea').text(json)
    }
  },

  async mounted () {
    const { dispatch } = this.$store

    await dispatch('users/fetchAll')
    await dispatch('contracts/fetchAll')

    const global = this
    $('#modalShowBodyInfo').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget)

      global.bodyToShow = button.data('body')
      global.mountTextBody()
    })

    $('#modalShowBodyInfo').on('hide.bs.modal', function (event) {
      global.bodyToShow = {}
    })
  },
  
  destroyed () {
    const { dispatch } = this.$store

    dispatch('users/cleanState')
    dispatch('contracts/cleanState')
  }
}
</script>

<style scoped>
  textarea {
    width: 100%;
    min-height: 30rem;
    font-family: "Lucida Console", Monaco, monospace;
    font-size: 0.8rem;
    line-height: 1.2;
  }
</style>